import React from 'react';
import {StyleSheet, View} from 'react-native';
import {useFocusEffect} from '@react-navigation/native';
import {observer} from 'mobx-react';

import ActivityIndicator from '../../components/ui-controls/ActivityIndicator';
import Button from '../../components/ui-controls/Button';
import ContentView from '../../components/ui-controls/layout/ContentView';
import {AppRoute} from '../../models/AppRoute';
import {RouteNavigatorScreenProps} from '../../models/navigationTypes';
import {StoreType} from '../../navigation/routes/types';
import {useStores} from '../../stores/use-stores';
import {
  isGiftCardsPromotion,
  navigateToGiftCardsShop,
} from '../../utils/giftCards';
import {getStoreType} from '../../utils/store';

const FallbackContent = ({
  onBuyAGiftCardPress,
}: {
  onBuyAGiftCardPress: () => void;
}) => (
  <ContentView>
    <View style={styles.addToCartButtonWrapper}>
      <Button title="BUY A GIFT CARD" onPress={onBuyAGiftCardPress} />
    </View>
  </ContentView>
);

export const GiftCardsPromotionWaiter = observer(
  ({
    navigation,
  }: RouteNavigatorScreenProps<AppRoute.GIFT_CARDS_PROMOTION_WAITER>) => {
    const {shopSelectionStore, promotionsStore} = useStores();

    const allPromotions = promotionsStore.rawPromotions;
    const giftCardPromotion =
      promotionsStore.rawPromotions?.find(isGiftCardsPromotion);

    useFocusEffect(() => {
      if (giftCardPromotion) {
        navigation.navigate(AppRoute.PROMOTION, {
          promotion: giftCardPromotion,
        });
      }
    });

    const handleBuyAGiftCardPressFallback = () => {
      const selectedStore = shopSelectionStore.selectedStore;
      const storeType = getStoreType(selectedStore);
      if (storeType === StoreType.GiftCardStore)
        navigation.navigate(AppRoute.GIFT_CARDS_MAIN);
      else navigateToGiftCardsShop();
    };

    if (allPromotions.length > 0 && !giftCardPromotion) {
      return (
        <FallbackContent
          onBuyAGiftCardPress={handleBuyAGiftCardPressFallback}
        />
      );
    }

    return <ActivityIndicator />;
  },
);

export default GiftCardsPromotionWaiter;

const styles = StyleSheet.create({
  bannerImage: {
    width: '100%',
    height: 250,
  },
  title: {
    textAlign: 'center',
    marginVertical: 8,
  },
  copy: {
    width: '100%',
    marginBottom: 16,
  },
  addToCartButtonWrapper: {
    width: '100%',
    alignItems: 'center',
    marginBottom: 16,
  },
});
